module.exports = __webpack_public_path__ + "media/21.7d9b016a.mp3";